import { render } from "./TableActionBtn.vue?vue&type=template&id=3d6e0702"
import script from "./TableActionBtn.vue?vue&type=script&lang=js"
export * from "./TableActionBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__